var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewportThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "viewportThree",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.929,
    height: 111,
    viewBox: "0 0 135.929 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(284.751 -171.876) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    transform: "translate(38.876 223.863)",
    fill: "none",
    stroke: "#f6c543",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 60.888,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 103,
    height: 52.888,
    rx: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    transform: "translate(38.876 148.823)",
    fill: "none",
    stroke: "#b5d36d",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 60.929,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 103,
    height: 52.929,
    rx: 14,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewportThree);
export default __webpack_public_path__ + "static/media/viewportThree.14b506657c352c02798f0e3584ea553a.svg";
export { ForwardRef as ReactComponent };